import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import EmailVerificationCodeModal from '@/modules/user/components/Verification/EmailVerificationModal/EmailVerificationCodeModal';
import EnterEmailVerificationModal from '@/modules/user/components/Verification/EmailVerificationModal/EnterEmailVerificationModal';
import { EmailVerificationStep } from '@/modules/user/components/Verification/verification.types';

import SuccessVerifiedModal from '../SuccessVerifiedModal';

interface Props {
  onSetVisible: (value: boolean) => void;
  defaultValue?: string;
  employerProvidedEmail?: string;
}

const EmailVerificationModal: React.FC<Props> = ({ onSetVisible, defaultValue, employerProvidedEmail }) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(EmailVerificationStep.ENTER_EMAIL);
  const [email, setEmail] = useState(defaultValue || '');

  return (
    <>
      {step === EmailVerificationStep.ENTER_EMAIL && (
        <EnterEmailVerificationModal
          email={email}
          employerProvidedEmail={employerProvidedEmail}
          setEmail={setEmail}
          setStep={setStep}
          onSetVisible={onSetVisible}
        />
      )}
      {step === EmailVerificationStep.EMAIL_VERIFICATION_CODE && (
        <EmailVerificationCodeModal
          email={email}
          onSetVisible={onSetVisible}
          onBack={() => setStep(EmailVerificationStep.ENTER_EMAIL)}
          onNext={() => setStep(EmailVerificationStep.EMAIL_VERIFIED_SUCCESSFULLY)}
        />
      )}
      {step === EmailVerificationStep.EMAIL_VERIFIED_SUCCESSFULLY && (
        <SuccessVerifiedModal
          subTitle={t('You can update your email address anytime in your Account Profile.')}
          onSetVisible={onSetVisible}
        />
      )}
    </>
  );
};

export default EmailVerificationModal;
